// extracted by mini-css-extract-plugin
export default {"shortcut":"ShortcutItem__shortcut--CmnOi","name":"ShortcutItem__name--c6Lka","value":"ShortcutItem__value--RU_wN"};